import { COUNTRY_CODE } from '@cemex-core/cmx-api';
import { mxConfig } from './mx/mx';
import { coConfig } from './co/co';
import { crConfig } from './cr/cr';
import { paConfig } from './pa/pa';
import { peConfig } from './pe/pe';
import { egConfig } from './eg/eg';
import { phConfig } from './ph/ph';
import { plConfig } from './pl/pl';
import { ukConfig } from './uk/uk';
import { usConfig } from './us/us';
import { svConfig } from './sv/sv';
import { doConfig } from './do/do';
import { gtConfig } from './gt/gt';
import { niConfig } from './ni/ni';
import { prConfig } from './pr/pr';
import { esConfig } from './es/es';
import { deConfig } from './de/de';

export const config = {
  [COUNTRY_CODE.MEXICO]: mxConfig,
  [COUNTRY_CODE.COLOMBIA]: coConfig,
  [COUNTRY_CODE.COSTA_RICA]: crConfig,
  [COUNTRY_CODE.PANAMA]: paConfig,
  [COUNTRY_CODE.PERU]: peConfig,
  [COUNTRY_CODE.EGYPT]: egConfig,
  [COUNTRY_CODE.PHILIPPINES]: phConfig,
  [COUNTRY_CODE.POLAND]: plConfig,
  [COUNTRY_CODE.UNITED_KINGDOM]: ukConfig,
  [COUNTRY_CODE.USA]: usConfig,
  [COUNTRY_CODE.EL_SALVADOR]: svConfig,
  [COUNTRY_CODE.DOMINICAN_REPUBLIC]: doConfig,
  [COUNTRY_CODE.GUATEMALA]: gtConfig,
  [COUNTRY_CODE.NICARAGUA]: niConfig,
  [COUNTRY_CODE.PUERTO_RICO]: prConfig,
  [COUNTRY_CODE.SPAIN]: esConfig,
  [COUNTRY_CODE.GERMANY]: deConfig,
};
